module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    staticClass: "adorn-bottom",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-2": "",
      "pt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 77,
      "imaSrc": "contenido/diapositiva_24",
      "imaAlt": "Calculadora para el presupuesto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Calculadora de presupuesto",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Calculadora"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("de")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" presupuesto")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeInDown dura_2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": "",
      "pt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Calculadora de presupuesto',
      "videoEmbed": "ADMINISTRACIONDINERO23CalculadoraPresupuestob (54).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('p', [_vm._v("Esta herramienta le permitirá "), _c('strong', [_vm._v("optimizar")]), _vm._v(" la administración de su dinero. Una vez finalice este curso encontrará desbloqueada esta herramienta en la sección"), _c('strong', [_vm._v(" Mi perfil")]), _vm._v(" para que pueda usarla cuantas veces lo necesite,\r\n        revisar continuamente su presupuesto, "), _c('strong', [_vm._v("descargar y guardar el documento en PDF")]), _vm._v(".\r\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5744905c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-23.vue
// module id = 994
// module chunks = 1